import React, {useCallback, useEffect, useState} from 'react';
import {View, ScrollView, Image, StyleSheet} from 'react-native';
import {connect, useDispatch} from 'react-redux';
import OrganizationsService from '../../services/OrganizationsService';
import { setOrganization } from '../../store/auth/authActions';
import IntegrationsService from '../../services/IntegrationsService';
import {basicStyles} from '../../styles/basic';
import AppText from '../../components/AppText';
import AppButton from '../../components/AppButton';
import {textStyles} from '../../styles/text';
import {IMAGE_PATH_INTEGRATION} from '../../config';
import FieldSet from '../../components/FieldSet';
import EStyleSheet from 'react-native-extended-stylesheet';
import ImportConfiguration from "../../components/ImportConfiguration";
import ImportConfigurationNoFile from "../../components/ImportConfigurationNoFile";

function ZapierIntegration(props) {
	const dispatch = useDispatch();
	const [integration, setIntegration] = useState({integrationImages: []});
	const [importConfiguration, setImportConfiguration] = useState({});
	const [token, setToken] = useState(props.auth.organization.organization_zapier_key || '');
	const [enabled, setEnabled] = useState(!!parseInt(props.auth.organization.organization_zapier_enabled));
	const [buttonChunkSize, setButtonChunkSize] = useState(2);
	const [editConfiguration, setEditConfiguration] = useState(false);
	const handleLayout = ({nativeEvent}) => {
		const {width} = nativeEvent.layout;

		if (width > 840) {
			setButtonChunkSize(2);
		} else {
			setButtonChunkSize(1);
		}
	};

	useEffect(() => {
		const getIntegration = async () => {
			const integrationData = await IntegrationsService.getIntegration(props.route.params.id);

			setIntegration(integrationData);
		};

		// const getZapierConfiguration = async () => {
		// 	const importData = await IntegrationsService.getOrganizationZapierConfiguration(props.auth.organization.organization_id);
		//
		// 	setImportConfiguration({
		// 		availableColumns: importData.availableColumns,
		// 		defaultConfiguration: importData.defaultConfiguration
		// 	});
		// };

		getIntegration();
		// getZapierConfiguration();
	}, [props.route.params.id, props.auth.organization.organization_id]);

	/**
	 * Handle zapier token save
	 */

	const handleTokenSave = useCallback(async () => {
		IntegrationsService.setOrganizationZapierToken(props.auth.organization.organization_id, token);

		if (token) {
			dispatch(setOrganization(await OrganizationsService.getOrganization(props.auth.organization.organization_id)));
		} else {
			setEnabled(false);
			await IntegrationsService.setOrganizationZapierEnabled(props.auth.organization.organization_id, false);
			dispatch(setOrganization(await OrganizationsService.getOrganization(props.auth.organization.organization_id)));
		}
	}, [props.auth, token]);

	/**
	 * Handle enabled toggle
	 */

	const handleEnabledChange = useCallback(async (value) => {

		await IntegrationsService.setOrganizationZapierEnabled(props.auth.organization.organization_id, value || false)
			.then(() => {
				setEnabled(value);
			})
			.catch((error) => {
				setEnabled(false);
			});
		dispatch(setOrganization(await OrganizationsService.getOrganization(props.auth.organization.organization_id)));
	});

	/**
	 * Handle import configuration save
	 */

	// const handleConfigurationSave = useCallback(async (columnsConfiguration) => {
	// 	await IntegrationsService.setOrganizationZapierConfiguration(props.auth.organization.organization_id, {
	// 		columnsConfiguration: JSON.stringify(columnsConfiguration)
	// 	});
	// 	dispatch(setOrganization(await OrganizationsService.getOrganization(props.auth.organization.organization_id)));
	// 	setEditConfiguration(false);
	// });

	const SaveTokenButton = () => {
		return <AppButton
			label="Save"
			theme="green"
			large={true}
			action={handleTokenSave}
		/>;
	};

	return (
		<>
			<ScrollView contentContainerStyle={basicStyles.flexScale} onLayout={handleLayout}>
				<View style={styles.contentWrapper}>
					<View style={[
						basicStyles.alignContentCenter,
						basicStyles.justifyContentSpaceBetween,
						styles.contentContainer
					]}>
						<View style={[styles.contentLeft, basicStyles.alignContentCenter]}>
							<View>
								<AppText style={[
									{fontSize: 28, marginBottom: 30},
									textStyles.bold,
								]}>
									{integration.integration_title}
								</AppText>
								<AppText style={{fontSize: 16, maxWidth: 465}}>
									{integration.integration_description}
								</AppText>
							</View>
						</View>
						<View style={[styles.contentRight, basicStyles.alignContentCenter]}>
							{
								integration.integrationImages.length ?
									<Image
										source={{uri: IMAGE_PATH_INTEGRATION + integration.integrationImages[0].integration_image_file}}
										style={styles.image} // todo: width or height HAS to be known in order for an image to scale...
										resizeMode="contain"
									/>
									: null
							}
						</View>
					</View>
					<FieldSet
						chunkSize={buttonChunkSize}
						fields={[
							{
								type: 'text',
								label: 'Access Token',
								value: token,
								onChangeText: setToken,
								wrapperStyle: styles.buttonStyles,
								inputStyle: styles.inputStyles,
								actionButton: <SaveTokenButton />
							},
							{
								type: 'toggle',
								label: 'Enable Zapier Integration',
								onChange: handleEnabledChange,
								value: enabled,
								disabled: !token
							},
							// {
							// 	type: 'button',
							// 	actionLabel: 'Edit Import Configuration',
							// 	action: () => setEditConfiguration(true),
							// 	wrapperStyle: {border: 'none', paddingLeft: 0},
							// 	labelWrapperStyle: {display: 'none'}
							// },
						]}
					/>
				</View>
			</ScrollView>
			{/*{*/}
			{/*	editConfiguration ?*/}
			{/*		<ImportConfigurationNoFile*/}
			{/*			availableColumns={importConfiguration.availableColumns}*/}
			{/*			defaultConfiguration={importConfiguration.defaultConfiguration}*/}
			{/*			onSubmit={handleConfigurationSave}*/}
			{/*			onOffClick={() => setEditConfiguration(false)}*/}
			{/*		/>*/}
			{/*		: null*/}
			{/*}*/}
		</>
	);
}

const mapStateToProps = (state) => {
	const {auth} = state;
	return {auth};
};

export default connect(mapStateToProps)(ZapierIntegration);


const styles = EStyleSheet.create({
	contentWrapper: {
		paddingTop: 70,
		paddingBottom: 70,
		paddingLeft: 40,
		paddingRight: 40,
	},
	contentContainer: {
		flexDirection: 'row',
		paddingBottom: 60
	},
	contentLeft: {
		width: '50%',
		paddingRight: 40
	},
	contentRight: {
		width: '50%',
	},
	image: {
		width: 408,
		height: 315,
		marginBottom: 10,
	},
	'@media (max-width: 920)': {
		contentContainer: {
			flexDirection: 'column'
		},
		contentLeft: {
			width: '100%',
			paddingBottom: 50,
		},
		contentRight: {
			width: '100%'
		}
	},
	'@media (max-width: 408)': {
		contentWrapper: {
			paddingLeft: 0,
			paddingRight: 0,
		},
		contentLeft: {
			paddingLeft: 20,
			paddingRight: 20,
		},
		image: {
			width: 350
		},
		inputStyles: {
			paddingBottom: 20,
		},
		buttonStyles: {
			height: 'auto', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'inherit'
		}
	},
	'@media (max-width: 350)': {
		contentLeft: {
			paddingBottom: 10,
		},
		image: {
			width: 280
		},
	}
});
